import Api from './Api'

export default {
  userLogin(email, password) {
    return Api().post('/user/login', {
      email,
      password
    });
  }
}